"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M875.893 435.055c22.265 0 40.076 17.28 38.592 38.88V985.12c0 21.6-17.812 38.879-40.076 38.879H150.076C127.81 1024 110 1006.72 110 985.121V475.374c0-21.6 17.811-38.879 40.076-38.879h57.887c8.906 0 14.843-7.2 14.843-14.4V282.42c0-159.835 136.555-287.992 301.31-282.232 157.335 5.76 279.047 135.356 279.047 287.992v132.477c0 8.64 7.422 14.4 14.843 14.4h57.887zM313.348 282.42h-1.485v139.677c0 8.64 7.422 14.4 14.843 14.4h374.041c8.906 0 14.843-7.2 14.843-14.4V288.179c0-105.117-83.12-194.395-191.473-200.154-115.775-5.76-210.77 83.517-210.77 194.394z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgLock, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;